const fragment = `
  id
  dayOfWeek
  isOpen
  hours
  salesHourable {
    __typename
    ... on Community {
      id
      name
    }
    ... on Project {
      id
      name
    }
  }
`;

export const listSalesHoursQuery = `
  query ListSalesHours(
    $filter: SalesHourFilterInput
  ) {
    items: listSalesHours(filter: $filter) {
      ${fragment}
    }
  }
`;

export const saveSalesHoursMutation = `
  mutation SaveSalesHours(
    $input: SaveSalesHoursInput!
  ) {
    items: saveSalesHours(input: $input) {
      ${fragment}
    }
  }
`;
